import { EntityRepository, Repository } from "typeorm";
import { QcClearanceInfo } from "../qc-clearance_info.entity";
import { Injectable } from "@nestjs/common";


@EntityRepository(QcClearanceInfo)
@Injectable()
export class QCClearanceInfoRepository extends Repository<QcClearanceInfo> {

}